import React from 'react';
import {useSelector} from 'react-redux';
import EventRolePermission from '../../pages/components/rolePermission/EventRolePermission';
import styled from 'styled-components';

// This matches the class name in your HTML
const LinkContainer = styled.div`
    text-align: center;
    direction: rtl;
    position: relative; /* Added to ensure proper stacking context */
    z-index: 10; /* Add a z-index to ensure it's above other elements */
    pointer-events: auto; /* Ensure pointer events are enabled */
    color: #161616;
`;

// This matches the class name in your HTML
const ReportLink = styled.a`
    margin: 0 4px;
    text-decoration: underline;
    pointer-events: auto; /* Explicitly enable pointer events */
    cursor: pointer; /* Add cursor pointer to make it clear it's clickable */
    position: relative; /* Ensure proper stacking context */
    z-index: 2; /* Add z-index */
    
    &:hover {
        color: #2980b9;
    }
`;

const RealtimeCustomPixel = () => {
    const eid = useSelector((s) => s.event.eid);
    
    if(eid === 27950) {
        return (
            <EventRolePermission rolePermission='view_dashboard' views={[]}>
                <LinkContainer>
                    דוחות מירון:
                    <ReportLink
                        href="https://my.tickchak.co.il/ajax/api/meron_stats"
                        onClick={(e) => e.stopPropagation()} /* Stop event propagation */
                        target="_blank" /* Open in new tab */
                        rel="noopener noreferrer"
                    >
                        רגיל
                    </ReportLink>
                    |
                    <ReportLink
                        href="https://my.tickchak.co.il/ajax/api/meron_stats?golan"
                        onClick={(e) => e.stopPropagation()} /* Stop event propagation */
                        target="_blank" /* Open in new tab */
                        rel="noopener noreferrer"
                    >
                        גולן
                    </ReportLink>
                    |
                    <ReportLink
                        href="https://my.tickchak.co.il/ajax/api/meron_dashboard"
                        onClick={(e) => e.stopPropagation()} /* Stop event propagation */
                        target="_blank" /* Open in new tab */
                        rel="noopener noreferrer"
                    >
                        דשבורד תנועה
                    </ReportLink>
                </LinkContainer>
            </EventRolePermission>
        );
    }
    
    return null;
};

export default RealtimeCustomPixel;
